import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/styles';
import { uiState } from 'react-redux-ui-state';
import { Link } from 'react-router-dom';

import SegmentClickTracker from 'components/SegmentClickTracker/SegmentClickTrackerContainer';

const propTypes = {
  classes: PropTypes.shape({}).isRequired,
  robotImage: PropTypes.string.isRequired,
  subtextColor: PropTypes.string.isRequired,
  setUiState: PropTypes.func.isRequired,
  createString: PropTypes.string.isRequired,
};

export function UnstyledNoInstancesPage({
  classes,
  robotImage,
  subtextColor,
  setUiState,
  createString,
}) {
  const robotList = [
    {
      image: '../images/logos/robot-dropped-icecream.png',
      color: '#e35746',
    },
    {
      image: '../images/logos/robot-juggling-purple.png',
      color: '#510d45',
    },
    {
      image: '../images/logos/robot-mohawk.png',
      color: '#32a2c2',
    },
    {
      image: '../images/logos/robot-withSpyglass.png',
      color: '#38b19b',
    },
    {
      image: '../images/logos/robot-withTools.png',
      color: '#38b19b',
    },
  ];

  function RandomRobot() {
    const robot = robotList[Math.floor(Math.random() * robotList.length)];
    if (!robotImage) {
      setUiState({
        robotImage: robot.image,
        subtextColor: robot.color,
      });
    }
  }

  RandomRobot();

  return (
    <React.Fragment>
      <div className={classes.root}>
        <div className={classes.textAndButtons}>
          <Typography variant="h1" className={classes.welcomeText} style={{ color: subtextColor }}>
            Welcome
          </Typography>
          <Typography variant="h3" className={classes.subText}>
            You have no Instances setup yet!
          </Typography>

          <div className={classes.theButtons}>
            <SegmentClickTracker buttonName="Create Instance (Get Started With An Instance)">
              <Link to={createString} className={classes.buttonLink}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.createInstanceButton}
                >
                  Get started with an instance
                </Button>
              </Link>
            </SegmentClickTracker>
          </div>
        </div>

        <div className={classes.imageArea}>
          <img className={classes.robot} src={robotImage} alt="" />
        </div>
      </div>
    </React.Fragment>
  );
}

UnstyledNoInstancesPage.propTypes = propTypes;

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'row',
    padding: '8px',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(20),

    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(3),
      flexDirection: 'column',
    },
  },
  welcomeText: {
    fontSize: '5.14rem',
    fontFamily: '"Libre Medium", sans-serif',
    fontWeight: 400,
  },
  subText: {
    color: theme.customColors.black,
    fontSize: '1.71rem',
    lineHeight: '2.57rem',
    letterSpacing: 1,
    fontFamily: '"Libre Medium", sans-serif',
  },
  theButtons: {
    maxWidth: 310,
  },
  createInstanceButton: {
    color: theme.customColors.white,
    fontWeight: 'bold',
    width: '100%',
  },
  robot: {
    height: 300,
  },
  buttonLink: {
    textDecoration: 'none',
  },
  orv4Link: {
    width: '100%',
    marginTop: '1rem',
  },
  textAndButtons: {
    marginRight: '3rem',
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      height: 300,
      alignSelf: 'unset',
      marginRight: 'unset',
    },
  },
  imageArea: {
    marginLeft: '3rem',

    [theme.breakpoints.down('md')]: {
      marginLeft: 'unset',
      marginTop: '3rem',
    },
  },
});

export const uiConfig = {
  name: 'NoInstancesPage',
  state: () => ({
    robotImage: '',
    subtextColor: '',
  }),
};

export default uiState(uiConfig)(withStyles(styles)(UnstyledNoInstancesPage));
